import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { loadTableData } from './actions'

function mapStateToProps(state, hocProps) {
    const module = hocProps?.module
    const id = hocProps?.id
    const block = hocProps?.block

    return {
        isLoading: state.getIn(
            ['ui', 'workspace', module, id, 'blocks', block, 'customData', 'assignedTenders', 'isLoading'],
            false
        ),
        loaded: state.getIn(
            ['ui', 'workspace', module, id, 'blocks', block, 'customData', 'assignedTenders', 'loaded'],
            false
        ),
        failed: state.getIn(
            ['ui', 'workspace', module, id, 'blocks', block, 'customData', 'assignedTenders', 'failed'],
            false
        ),
        data: state.getIn(
            ['ui', 'workspace', module, id, 'blocks', block, 'customData', 'assignedTenders', 'data'],
            []
        ),
        dataLocale: state.getIn(
            ['ui', 'workspace', module, id, 'blocks', block, 'customData', 'assignedTenders', 'dataLocale'],
            null
        ),
        pagination: state.getIn(
            ['ui', 'workspace', module, id, 'blocks', block, 'customData', 'assignedTenders', 'query', 'pagination'],
            {}
        ),
        sorted: state.getIn(
            ['ui', 'workspace', module, id, 'blocks', block, 'customData', 'assignedTenders', 'query', 'sorted'],
            []
        ),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            loadTableData,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
